import "./datatableSolve.scss";
import { DataGrid } from "@mui/x-data-grid";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useMemo} from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {fetchSearchData, resetFilters, setField, setPage, setPageSize} from "../../slice/searchSlice";
import {useDispatch, useSelector} from "react-redux";
import debounce from "lodash.debounce";
import useRegions from "../../hooks/useRegions";

const DatatableSolve = ({columns}) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];

    const dispatch = useDispatch();
    const search = useSelector((state) => state.search);
    const { regions } = useRegions();

    // Fetch data setiap ada perubahan filter atau pagination
    const debouncedFetch = useMemo(
        () =>
            debounce((params) => {
                dispatch(fetchSearchData({ path, params }));
            }, 500), // delay 500ms
        [dispatch, path]
    );

    useEffect(() => {
        debouncedFetch(search);

        // Cancel debounce on unmount / change
        return () => debouncedFetch.cancel();
    }, [
        search.page,
        search.pageSize,
        search.query,
        search.queryTicketId,
        search.queryStatusId,
        search.queryCustomer,
        search.queryMonth,
        search.queryYear,
        search.regionId,
        search.startDate,
        search.endDate,
        search.order,
        debouncedFetch,
    ]);

    const handleSelectRegionID = (e) => {
        dispatch(
            setField({
                name: "regionId",
                value: e.target.value,
            })
        );
    };

    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/${path}/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>
                        <Link to={`/${path}/update/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update
                            </div>
                        </Link>
                        <Link to={`/closed/create/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Create Close
                            </div>
                        </Link>

                    </div>
                );
            },
        },
    ];
    return (
        <div className="datatable">
            <div className="datatableTitle">
                Ticket {path.toUpperCase()}

            </div>
            <div className="column-search">
                <div className="search">
                    <input
                        type="text"
                        placeholder="userId"
                        value={search.query}
                        onChange={(e) => dispatch(setField({name: "query", value: e.target.value}))}
                    />
                    <SearchOutlinedIcon/>

                    <input
                        type="text"
                        placeholder="TicketId"
                        value={search.queryTicketId}
                        onChange={(e) => dispatch(setField({name: "queryTicketId", value: e.target.value}))}
                    />
                </div>

                <div className="search">
                    <input
                        type="text"
                        placeholder="StatusID"
                        value={search.queryStatusId}
                        onChange={(e) =>
                            dispatch(setField({name: "queryStatusId", value: e.target.value}))
                        }
                    />
                    <SearchOutlinedIcon/>

                    <input
                        type="text"
                        placeholder="Segment Cust"
                        value={search.queryCustomer}
                        onChange={(e) =>
                            dispatch(setField({name: "queryCustomer", value: e.target.value}))
                        }
                    />
                </div>

                <div className="search">
                    <input
                        type="text"
                        placeholder="Month"
                        value={search.queryMonth}
                        onChange={(e) => dispatch(setField({name: "queryMonth", value: e.target.value}))}
                    />
                    <SearchOutlinedIcon/>

                    <input
                        type="text"
                        placeholder="Year"
                        value={search.queryYear}
                        onChange={(e) => dispatch(setField({name: "queryYear", value: e.target.value}))}
                    />
                </div>

                <div className="search">
                    <input
                        type="date"
                        // onChange={handleStartChange}
                        onChange={(e) =>
                            dispatch(setField({name: "startDate", value: e.target.value}))
                        }
                        style={{
                            padding: "8px 12px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                        }}/>--

                    <input
                        type="date"
                        onChange={(e) =>
                            dispatch(setField({name: "endDate", value: e.target.value}))
                        }
                        style={{
                            padding: "8px 12px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                        }}/>
                </div>

                <div className="search">
                    <select id="order" onChange={(e) =>
                        dispatch(setField({name: "order", value: e.target.value}))
                    }>
                        <option value="DESC">DESC</option>
                        <option value="ASC">ASC</option>
                    </select>
                    <select id="region_id" onChange={handleSelectRegionID}>
                        <option value="">Pilih Region Id</option>
                        {regions.map((reg) => (
                          <option key={reg.id} value={reg.id}>
                            {reg.id}
                          </option>
                        ))}
                    </select>
                </div>
                <div className="search">
                    <button onClick={() => dispatch(resetFilters())} className="reset">
                        Reset
                    </button>
                </div>
                <div className="search">

                </div>


            </div>
            <DataGrid
                className="datagrid"
                columns={columns.concat(actionColumn)}
                autoHeight
                rows={search.data}
                rowCount={search.total}
                loading={search.loading}
                pagination
                paginationMode="server"
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                page={search.page - 1}
                pageSize={search.pageSize}
                onPageChange={(page) => dispatch(setPage(page + 1))}
                onPageSizeChange={(size) => dispatch(setPageSize(size))}

            />
        </div>
    );
};

export default DatatableSolve;
